import m from "./atoms-v21143.js";
import a from "./atoms-v21144.js";
import i from "./atoms-v21145.js";
function d(t, r) {
  i(2, arguments);
  var e = a(t).getTime(), o = m(r);
  return new Date(e + o);
}
export {
  d as default
};
